module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "logoBlack.54c44ee4.png" + "?" + Date.now();